var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleConfetti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 591
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "circle-confetti_svg__a",
    width: 969,
    height: 591,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F29DC3",
    cx: 49.846,
    cy: 110.56,
    r: 2.511
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE300",
    cx: 88.591,
    cy: 37.06,
    r: 2.909
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61B340",
    cx: 35.864,
    cy: 88.56,
    r: 3.136
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F08302",
    cx: 44.572,
    cy: 65.17,
    r: 3.322,
    transform: "rotate(-128 44.572 65.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F08302",
    cx: 125.402,
    cy: 70.455,
    r: 3.82,
    transform: "rotate(-46 125.402 70.455)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F08302",
    cx: 157.8,
    cy: 33.603,
    r: 3.621,
    transform: "rotate(-150 157.8 33.603)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE300",
    cx: 313.762,
    cy: 16.118,
    r: 2.502,
    transform: "rotate(-52 313.762 16.118)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F29DC3",
    cx: 398.516,
    cy: 22.061,
    r: 2.611,
    transform: "rotate(27 398.516 22.061)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79CDF4",
    cx: 493.629,
    cy: 27.293,
    r: 5.905,
    transform: "rotate(23 493.629 27.293)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61B340",
    cx: 621.194,
    cy: 20.527,
    r: 2.886,
    transform: "rotate(-16 621.194 20.527)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE300",
    cx: 776.524,
    cy: 60.25,
    r: 2.822,
    transform: "rotate(-64 776.524 60.25)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE300",
    cx: 900.986,
    cy: 18.447,
    r: 2.822,
    transform: "rotate(122 900.986 18.447)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F08302",
    cx: 28.181,
    cy: 120.385,
    r: 3.72,
    transform: "rotate(-55 28.181 120.385)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F29DC3",
    cx: 216.462,
    cy: 115.171,
    r: 2.084,
    transform: "rotate(58 216.462 115.171)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F29DC3",
    cx: 279.984,
    cy: 121.56,
    r: 2.611,
    transform: "rotate(17 279.984 121.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F29DC3",
    cx: 440.559,
    cy: 106.734,
    r: 2.235,
    transform: "rotate(108 440.559 106.734)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F29DC3",
    cx: 573.557,
    cy: 100.988,
    r: 1.657,
    transform: "rotate(169 573.557 100.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F29DC3",
    cx: 628.374,
    cy: 132.637,
    r: 1.959,
    transform: "rotate(-38 628.374 132.637)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F08302",
    cx: 820.23,
    cy: 137.361,
    r: 2.226,
    transform: "rotate(-83 820.23 137.361)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F29DC3",
    cx: 888.899,
    cy: 118.612,
    r: 2.159,
    transform: "rotate(148 888.899 118.612)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79CDF4",
    cx: 50.629,
    cy: 154.174,
    r: 6.169,
    transform: "rotate(-173 50.629 154.174)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61B340",
    cx: 199.934,
    cy: 212.486,
    r: 3.576,
    transform: "rotate(-63 199.934 212.486)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61B340",
    cx: 308.526,
    cy: 169.104,
    r: 3.168,
    transform: "rotate(-2 308.526 169.104)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F29DC3",
    cx: 436.052,
    cy: 189.881,
    r: 2.436,
    transform: "rotate(-84 436.052 189.881)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F29DC3",
    cx: 541.326,
    cy: 206.955,
    r: 2.411,
    transform: "rotate(-11 541.326 206.955)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79CDF4",
    cx: 672.277,
    cy: 191.96,
    r: 5.378,
    transform: "rotate(-87 672.277 191.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79CDF4",
    cx: 837.375,
    cy: 152.69,
    r: 4.482,
    transform: "rotate(167 837.375 152.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F29DC3",
    cx: 936.557,
    cy: 221.926,
    r: 2.109,
    transform: "rotate(96 936.557 221.926)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE300",
    cx: 100.396,
    cy: 251.285,
    r: 3.288,
    transform: "rotate(-64 100.396 251.285)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61B340",
    cx: 141.928,
    cy: 272.644,
    r: 3.544,
    transform: "rotate(-101 141.928 272.644)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79CDF4",
    cx: 363.095,
    cy: 249.682,
    r: 4.904,
    transform: "rotate(38 363.095 249.682)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79CDF4",
    cx: 382.523,
    cy: 255.614,
    r: 3.955,
    transform: "rotate(-68 382.523 255.614)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79CDF4",
    cx: 526.903,
    cy: 247.948,
    r: 4.956,
    transform: "rotate(-69 526.903 247.948)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F08302",
    cx: 650.999,
    cy: 284.803,
    r: 3.72,
    transform: "rotate(63 650.999 284.803)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79CDF4",
    cx: 767.783,
    cy: 287.288,
    r: 3.269,
    transform: "rotate(4 767.783 287.288)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79CDF4",
    cx: 909.997,
    cy: 231.598,
    r: 4.271,
    transform: "rotate(-77 909.997 231.598)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE300",
    cx: 98.625,
    cy: 297.233,
    r: 1.92,
    transform: "rotate(164 98.625 297.233)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61B340",
    cx: 192.138,
    cy: 364.758,
    r: 2.823,
    transform: "rotate(132 192.138 364.758)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79CDF4",
    cx: 360.679,
    cy: 299.197,
    r: 4.271,
    transform: "rotate(-19 360.679 299.197)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61B340",
    cx: 404.321,
    cy: 334.734,
    r: 1.882,
    transform: "rotate(-88 404.321 334.734)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE300",
    cx: 559.996,
    cy: 357.141,
    r: 2.007,
    transform: "rotate(-167 559.996 357.141)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F08302",
    cx: 609.747,
    cy: 301.133,
    r: 2.259,
    transform: "rotate(81 609.747 301.133)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79CDF4",
    cx: 780.658,
    cy: 369.843,
    r: 3.744,
    transform: "rotate(46 780.658 369.843)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F29DC3",
    cx: 897.519,
    cy: 364.899,
    r: 2.034,
    transform: "rotate(170 897.519 364.899)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61B340",
    cx: 107.251,
    cy: 372.502,
    r: 3.764,
    transform: "rotate(-8 107.251 372.502)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F08302",
    cx: 194.522,
    cy: 372.939,
    r: 2.757,
    transform: "rotate(24 194.522 372.939)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F08302",
    cx: 343.873,
    cy: 435.056,
    r: 2.491,
    transform: "rotate(-158 343.873 435.056)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE300",
    cx: 406.932,
    cy: 374.163,
    r: 3.2,
    transform: "rotate(124 406.932 374.163)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F08302",
    cx: 573.212,
    cy: 376.711,
    r: 2.657,
    transform: "rotate(-54 573.212 376.711)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F08302",
    cx: 622.495,
    cy: 404.433,
    r: 3.521,
    transform: "rotate(-6 622.495 404.433)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F29DC3",
    cx: 815.347,
    cy: 412.867,
    r: 2.963,
    transform: "rotate(-170 815.347 412.867)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F29DC3",
    cx: 871.789,
    cy: 413.643,
    r: 2.486,
    transform: "rotate(63 871.789 413.643)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE300",
    cx: 35.101,
    cy: 478.278,
    r: 3.462,
    transform: "rotate(-122 35.101 478.278)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F08302",
    cx: 131.472,
    cy: 478.405,
    r: 2.026,
    transform: "rotate(-80 131.472 478.405)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F29DC3",
    cx: 308.493,
    cy: 492.029,
    r: 2.134,
    transform: "rotate(-87 308.493 492.029)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79CDF4",
    cx: 410.303,
    cy: 493.162,
    r: 4.218,
    transform: "rotate(76 410.303 493.162)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F08302",
    cx: 585.741,
    cy: 480.106,
    r: 2.292,
    transform: "rotate(-44 585.741 480.106)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79CDF4",
    cx: 621.056,
    cy: 449.52,
    r: 5.905,
    transform: "rotate(160 621.056 449.52)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE300",
    cx: 823.217,
    cy: 479.963,
    r: 1.746,
    transform: "rotate(-47 823.217 479.963)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F29DC3",
    cx: 920.709,
    cy: 452.049,
    r: 1.532,
    transform: "rotate(135 920.709 452.049)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61B340",
    cx: 3.802,
    cy: 545.537,
    r: 2.321,
    transform: "rotate(122 3.802 545.537)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE300",
    cx: 240.758,
    cy: 526.821,
    r: 2.153,
    transform: "rotate(-123 240.758 526.821)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F08302",
    cx: 280.545,
    cy: 546.114,
    r: 3.089,
    transform: "rotate(103 280.545 546.114)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79CDF4",
    cx: 376.737,
    cy: 514.244,
    r: 6.169,
    transform: "rotate(-105 376.737 514.244)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F08302",
    cx: 509.274,
    cy: 556.483,
    r: 3.056,
    transform: "rotate(-138 509.274 556.483)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F08302",
    cx: 711.809,
    cy: 545.787,
    r: 3.754,
    transform: "rotate(65 711.809 545.787)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61B340",
    cx: 807.419,
    cy: 524.239,
    r: 2.478,
    transform: "rotate(34 807.419 524.239)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79CDF4",
    cx: 903.815,
    cy: 585.128,
    r: 4.376,
    transform: "rotate(-176 903.815 585.128)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#circle-confetti_svg__a)",
    width: "100%",
    height: "100%"
  })));
}
export default SvgCircleConfetti;